import { useCallback, useMemo } from "react";

import { INFO_FIELDS } from "@is/constants";
import { CheckoutInputFields, FieldState } from "@is/types";

type Props = {
  options: FieldState[];
};

const useManageCheckoutFormSection = ({ options }: Props) => {
  const groupedOptions = useMemo(
    () =>
      options.reduce((acc, currentValue) => {
        const lastItem = acc[acc.length - 1];

        if (
          currentValue.name === CheckoutInputFields.City ||
          currentValue.name === CheckoutInputFields.ZipCode
        ) {
          if (Array.isArray(lastItem)) {
            lastItem.push(currentValue);
            lastItem.sort((current, next) => {
              const currentName = current.name.toLowerCase();
              const nextName = next.name.toLowerCase();

              return nextName.localeCompare(currentName);
            });
          } else {
            acc.push([currentValue]);
          }
        } else {
          acc.push(currentValue);
        }

        return acc;
      }, []),
    [options]
  );

  const selectedFieldContainAllOptions = useCallback(
    (fields: string[], options: string[]) => {
      if (fields.length !== options.length) {
        return false;
      }

      return fields.every((item) => options.includes(item));
    },
    []
  );

  const fullWidthPhoneOrEmailField = useMemo(() => {
    const optionsNames = options.map((option) => option.name);

    const selectedNamesAndPhoneOrEmailFields = selectedFieldContainAllOptions(
      INFO_FIELDS,
      optionsNames
    );

    const selectedOnlyPhoneOrEmailField = selectedFieldContainAllOptions(
      [CheckoutInputFields.PhoneNumberOrEmail],
      optionsNames
    );

    return selectedOnlyPhoneOrEmailField || selectedNamesAndPhoneOrEmailFields;
  }, [options, selectedFieldContainAllOptions]);

  return {
    groupedOptions,
    fullWidthPhoneOrEmailField,
  };
};

export default useManageCheckoutFormSection;
